<div class="document-type mt-4">
  <h6>{{ type }}</h6>
</div>
<div class="document-title mt-2">
  <h5 style="color: var(--text-color-1)">{{ titleLevel1 | stripHtml | formatLongText: 100 }}</h5>
</div>
<div class="document-coordinates mt-2">{{ titleLevel2 }}</div>
<div class="document-date-created mt-2">{{ 'MAP.CREATED' | translate }} {{ titleLevel3 }}</div>
